import {createStyles} from '@mantine/core';
import React from 'react';

import {ProgressToolCall} from 'llm/chat-library/progress/ProgressTypes';
import {ToolDetail} from 'llm/chat-library/tool-details/ToolDetail';
import {useToolDisplayName} from 'llm/chat-library/tool-details/useToolDisplayName';
import {MCPToolMappingProvider} from 'llm/mcp-client-library/MCPToolMappingContext';
import {ProcedureToolMappingProvider} from 'llm/procedure-tool-library/ProcedureToolMappingContext';

export interface ChatExportAppendixProps {
  toolCalls: Array<ProgressToolCall>;
  chatSessionId: string;
}

const useStyles = createStyles(() => ({
  appendix: {
    marginTop: 48,
    paddingTop: 24,
    borderTop: '1px solid #e0e0e0',
    breakBefore: 'page',
  },
  appendixTitle: {
    fontSize: 18,
    fontWeight: 600,
    marginBottom: 24,
  },
  toolCallSection: {
    marginBottom: 32,
  },
  toolCallTitle: {
    fontSize: 18,
    fontWeight: 600,
    marginBottom: 12,
  },
}));

function ChatExportAppendixContents({toolCalls, chatSessionId}: ChatExportAppendixProps): JSX.Element | null {
  const {classes} = useStyles();
  const getToolDisplayName = useToolDisplayName();

  if (toolCalls.length === 0) {
    return null;
  }

  return (
    <section className={classes.appendix}>
      <h2 className={classes.appendixTitle}>Appendix: Tool calls</h2>
      {toolCalls.map((toolCall, index) => (
        <article key={toolCall.toolId || index} className={classes.toolCallSection}>
          <h3 className={classes.toolCallTitle}>
            {getToolDisplayName(toolCall.tool, toolCall.args, toolCall.status)}
          </h3>
          <ToolDetail toolCall={toolCall} chatSessionId={chatSessionId} />
        </article>
      ))}
    </section>
  );
}

export function ChatExportAppendix(props: ChatExportAppendixProps): JSX.Element | null {
  return (
    <MCPToolMappingProvider>
      <ProcedureToolMappingProvider toolCalls={props.toolCalls}>
        <ChatExportAppendixContents {...props} />
      </ProcedureToolMappingProvider>
    </MCPToolMappingProvider>
  );
}
